import { render } from "./EditAccountConfirm.vue?vue&type=template&id=35cc3c92"
import script from "./EditAccountConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./EditAccountConfirm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/EditAccountConfirm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35cc3c92"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35cc3c92', __exports__)) {
    api.reload('35cc3c92', __exports__)
  }
  
  module.hot.accept("./EditAccountConfirm.vue?vue&type=template&id=35cc3c92", () => {
    api.rerender('35cc3c92', render)
  })

}


export default __exports__